import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDuration = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9.50003 16.3946C4.70001 16.3946 2 13.6946 2 8.89456C2 4.09454 4.70001 1.39453 9.50003 1.39453C14.3 1.39453 17 4.09454 17 8.89456C17 13.6946 14.3 16.3946 9.50003 16.3946Z",
		stroke: "#975EDE",
		strokeWidth: 1.75001,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.5625 5.24609V8.91251L11.7624 11.1124",
		stroke: "#975EDE",
		strokeWidth: 1.75001,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgDuration;
